function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M0 320c0-88.36 35.812-168.368 93.722-226.278S231.64 0 320 0c88.359 0 168.368 35.812 226.278 93.722S639.999 231.641 639.999 320c0 88.36-35.811 168.368-93.721 226.278C488.368 604.188 408.358 640 320 640c-88.36 0-168.368-35.812-226.278-93.722S0 408.359 0 320zm219.605-51.745c-9.284-9.047-24.154-8.834-33.19.45-9.035 9.295-8.822 24.153.461 33.189l117.297 113.753 16.359-16.831-16.382 16.901c9.33 9.048 24.236 8.812 33.284-.52.26-.26.52-.543.755-.814l115.017-112.49c9.296-9.036 9.497-23.894.461-33.19-9.035-9.283-23.894-9.496-33.19-.448l-100.004 97.808-100.867-97.808zm-92.6-141.25C77.611 176.4 47.067 244.632 47.067 320c0 75.367 30.544 143.6 79.938 192.995C176.4 562.39 244.632 592.933 320 592.933c75.368 0 143.6-30.543 192.995-79.938C562.39 463.601 592.933 395.368 592.933 320c0-75.367-30.543-143.6-79.938-192.995C463.601 77.611 395.368 47.067 320 47.067c-75.367 0-143.6 30.544-192.995 79.938z",
  fillRule: "nonzero"
});

var SvgJobsExtendViewDown = function SvgJobsExtendViewDown(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 640 640",
    shapeRendering: "geometricPrecision",
    textRendering: "geometricPrecision",
    imageRendering: "optimizeQuality",
    fillRule: "evenodd",
    clipRule: "evenodd",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgJobsExtendViewDown, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/jobs_extendView_down.aaeef131.svg";
export { ForwardRef as ReactComponent };